// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.st-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 14px;
  align-items: start;
}
.st-col {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}
.st-card {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.st-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.st-ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--v2-border);
  background: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  color: var(--v2-primary);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
.st-ai-btn:hover {
  border-color: var(--v2-primary);
}
.st-ai-btn:disabled {
  color: var(--v2-faint);
  cursor: default;
}
.st-textarea,
.st-input {
  font: inherit;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  resize: vertical;
  color: var(--v2-primary);
  width: 100%;
  box-sizing: border-box;
  outline: none;
}
.st-input {
  height: 38px;
  padding: 0 12px;
  border-radius: 9px;
}
.st-textarea:focus,
.st-input:focus {
  border-color: var(--v2-primary);
}
.st-model-head {
  display: flex;
  gap: 12px;
  align-items: center;
}
.st-cap {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--v2-muted) !important;
}
.st-rec {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
  font-weight: 600;
  white-space: nowrap;
}
.st-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-top: 10px;
  font-size: 13px;
  color: var(--v2-text-2);
}
.st-styles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.st-style {
  text-align: left;
  font: inherit;
  border: 1px solid var(--v2-border);
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  color: var(--v2-primary);
  min-width: 0;
}
.st-style.is-on {
  border: 2px solid var(--v2-primary);
  padding: 9px;
}
.st-switch-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  border-top: 1px solid var(--v2-border-soft);
  padding-top: 10px;
  margin-top: 2px;
}
.st-switch {
  width: 44px;
  height: 26px;
  flex: none;
  border-radius: 999px;
  border: 0;
  background: #d1d5db;
  position: relative;
  cursor: pointer;
  padding: 0;
}
.st-switch span {
  position: absolute;
  left: 3px;
  top: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.15s;
}
.st-switch.is-on {
  background: var(--v2-primary);
}
.st-switch.is-on span {
  left: 21px;
}
.st-delete {
  font: inherit;
  font-size: 13px;
  color: var(--v2-red);
  align-self: flex-start;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}
.st-proposal {
  white-space: pre-wrap;
  background: var(--v2-bg);
  border: 1px solid var(--v2-border);
  border-radius: 10px;
  padding: 12px 14px;
  max-height: 50vh;
  overflow: auto;
  font-size: 14px;
  color: var(--v2-primary);
}
.st-sugg {
  background: var(--v2-blue-bg);
  border: 1px solid #dbeafe;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.st-sugg ul {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--v2-text-2);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/assistant-settings/settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".st-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n  gap: 14px;\n  align-items: start;\n}\n.st-col {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n.st-card {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.st-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n.st-ai-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid var(--v2-border);\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--v2-primary);\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.st-ai-btn:hover {\n  border-color: var(--v2-primary);\n}\n.st-ai-btn:disabled {\n  color: var(--v2-faint);\n  cursor: default;\n}\n.st-textarea,\n.st-input {\n  font: inherit;\n  font-size: 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  padding: 10px 12px;\n  resize: vertical;\n  color: var(--v2-primary);\n  width: 100%;\n  box-sizing: border-box;\n  outline: none;\n}\n.st-input {\n  height: 38px;\n  padding: 0 12px;\n  border-radius: 9px;\n}\n.st-textarea:focus,\n.st-input:focus {\n  border-color: var(--v2-primary);\n}\n.st-model-head {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n.st-cap {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--v2-muted) !important;\n}\n.st-rec {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n  font-weight: 600;\n  white-space: nowrap;\n}\n.st-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  margin-top: 10px;\n  font-size: 13px;\n  color: var(--v2-text-2);\n}\n.st-styles {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n.st-style {\n  text-align: left;\n  font: inherit;\n  border: 1px solid var(--v2-border);\n  background: #fff;\n  border-radius: 10px;\n  padding: 10px;\n  cursor: pointer;\n  color: var(--v2-primary);\n  min-width: 0;\n}\n.st-style.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 9px;\n}\n.st-switch-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  border-top: 1px solid var(--v2-border-soft);\n  padding-top: 10px;\n  margin-top: 2px;\n}\n.st-switch {\n  width: 44px;\n  height: 26px;\n  flex: none;\n  border-radius: 999px;\n  border: 0;\n  background: #d1d5db;\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n}\n.st-switch span {\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  transition: left 0.15s;\n}\n.st-switch.is-on {\n  background: var(--v2-primary);\n}\n.st-switch.is-on span {\n  left: 21px;\n}\n.st-delete {\n  font: inherit;\n  font-size: 13px;\n  color: var(--v2-red);\n  align-self: flex-start;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n.st-proposal {\n  white-space: pre-wrap;\n  background: var(--v2-bg);\n  border: 1px solid var(--v2-border);\n  border-radius: 10px;\n  padding: 12px 14px;\n  max-height: 50vh;\n  overflow: auto;\n  font-size: 14px;\n  color: var(--v2-primary);\n}\n.st-sugg {\n  background: var(--v2-blue-bg);\n  border: 1px solid #dbeafe;\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.st-sugg ul {\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: var(--v2-text-2);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
